import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const header = (theme: Theme) => css`
  background-color: ${theme.surface.level1};
  padding: 1rem 0;
`;

export const wrapper = css`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1rem;
`;

export const backWrapper = css`
  display: flex;
  align-items: center;
  justify-self: start;
`;

export const backButton = (theme: Theme) => css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.xsmall};
  color: ${theme.system.textBase};
  text-decoration: underline;
`;

export const backButtonMobile = (theme: Theme) => css`
  display: inline-flex;
  align-items: center;
  color: ${theme.system.textBase};
`;

export const stepperWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
`;

export const mobileStepperWrapper = css`
  padding: 0.5rem 1rem;
`;

export const stepperNav = css`
  width: 450px;

  @media (max-width: ${dimensions.tabletMax}) {
    max-width: 100%;
    width: auto;
  }
`;

export const secureBadge = css`
  display: flex;
  align-items: center;
  justify-self: end;
`;

export const secureIcon = css`
  margin-right: 0.5rem;
`;
